import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Recommendations from "../views/Recommendations.vue";
import Details from "../views/Details.vue";
import Provider from "../views/Provider.vue";
import Assessment from "../views/Assessment.vue";
import Blog from "../views/Blog.vue";
import Search from "../views/Search.vue";
import Cart from "../views/Cart.vue";
import SeeAll from "../views/SeeAll.vue";
import Refine from "../views/Refine.vue";
import Contact from "../views/Contact.vue";
import VideoAsk from "../views/VideoAsk.vue";
import ReviewsAll from "../views/ReviewsAll.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/ReviewsAll",
    name: "ReviewsAll",
    component: ReviewsAll,
  },
  {
    path: "/VideoAsk",
    name: "VideoAsk",
    component: VideoAsk,
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
  {
    path: "/refine",
    name: "Refine",
    component: Refine,
  },
  {
    path: "/seeAll",
    name: "SeeAll",
    component: SeeAll,
  },

  {
    path: "/cart",
    name: "Cart",
    component: Cart,
  },
  {
    path: "/search",
    name: "Search",
    component: Search,
  },
  {
    path: "/blog",
    name: "Blog",
    component: Blog,
  },
  {
    path: "/assessment",
    name: "Assessment",
    component: Assessment,
  },
  {
    path: "/details",
    name: "Details",
    component: Details,
  },
  {
    path: "/recommendations",
    name: "Recommendations",
    component: Recommendations,
  },
  {
    path: "/provider",
    name: "Provider",
    component: Provider,
  },
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
